// extracted by mini-css-extract-plugin
module.exports = {"templateFilesContent":"TemplateFiles_templateFilesContent__QP-8o","tabContainer":"TemplateFiles_tabContainer__15hvs","tabContent":"TemplateFiles_tabContent__3RupP"};